import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '../../store/themeSlice';
import Styles from './themeToggleNav.module.css';

export default function ThemeToggleNav() {
    const dispatch = useDispatch();
    const theme = useSelector((state) => state.theme.mode);
    const isDark = theme === 'dark';

    const handleToggle = () => {
        dispatch(toggleTheme());
    };

    return (
        <button
            onClick={handleToggle}
            className={`${Styles.toggleSwitch} ${isDark ? Styles.dark : ''}`}
            aria-label="Toggle theme"
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            <div className={Styles.toggleTrack}>
                <div className={Styles.clouds}>
                    <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="14" r="5" fill="white" fillOpacity="0.8" />
                        <circle cx="18" cy="10" r="6" fill="white" fillOpacity="0.8" />
                        <circle cx="24" cy="14" r="5" fill="white" fillOpacity="0.8" />
                        <rect x="12" y="14" width="12" height="5" fill="white" fillOpacity="0.8" />
                        <circle cx="8" cy="16" r="3" fill="white" fillOpacity="0.5" />
                        <circle cx="28" cy="15" r="4" fill="white" fillOpacity="0.5" />
                    </svg>
                </div>
                <div className={Styles.stars}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6 Q12 10 16 10 Q12 10 12 14 Q12 10 8 10 Q12 10 12 6 Z" fill="white" fillOpacity="0.9" />
                        <path d="M22 14 Q22 16 24 16 Q22 16 22 18 Q22 16 20 16 Q22 16 22 14 Z" fill="white" fillOpacity="0.7" />
                        <path d="M7 18 Q7 19 8 19 Q7 19 7 20 Q7 19 6 19 Q7 19 7 18 Z" fill="white" fillOpacity="0.8" />
                        <circle cx="8" cy="8" r="1.5" fill="white" fillOpacity="0.6" />
                        <circle cx="20" cy="8" r="1" fill="white" fillOpacity="0.5" />
                    </svg>
                </div>
                <div className={Styles.toggleThumb}>
                    <div className={Styles.moonGlow}></div>
                    <div className={Styles.iconContainer}>
                        <svg className={Styles.sunIcon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="5" fill="#FFE169" />
                            <path d="M12 2V4M12 20V22M4 12H2M22 12H20M4.92893 4.92893L6.34315 6.34315M17.6569 17.6569L19.0711 19.0711M4.92893 19.0711L6.34315 17.6569M17.6569 6.34315L19.0711 4.92893" stroke="#FFE169" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <svg className={Styles.moonIcon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" fill="white" />
                        </svg>
                    </div>
                </div>
            </div>
        </button>
    );
}
